module.exports = __webpack_public_path__ + "img/E5.6bc51b4d.png";